export interface OrderDialogImportedFieldsSource {
  customerRequest: string;
  includedItems: string;
}

export interface OrderDialogImportedField {
  label: "お客様ご要望" | "同梱品";
  text: string;
}

function importedFieldText(value: string, emptyText: string): string {
  return value.trim().length > 0 ? value : emptyText;
}

export function orderDialogImportedFields(
  order: OrderDialogImportedFieldsSource,
): OrderDialogImportedField[] {
  return [
    {
      label: "お客様ご要望",
      text: importedFieldText(order.customerRequest, "お客様ご要望はありません。"),
    },
    {
      label: "同梱品",
      text: importedFieldText(order.includedItems, "同梱品はありません。"),
    },
  ];
}
